import { useEffect, useState } from "react";
import { KeyRound, IdCard, X } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { SignaturePad } from "../SignaturePad";

function LoanDialog({ k, onClose, onDone }) {
  const back = !!k.loan;
  const [f, setF] = useState({ name: "", company: "" });
  const [sig, setSig] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const fd = new FormData();
      if (!back) { fd.append("borrower_name", f.name); fd.append("borrower_company", f.company); }
      if (sig) fd.append("signature", sig);
      await http.post(`/agent-app/keys/${k.id}/${back ? "return" : "lend"}`, fd);
      onDone();
    } catch (er) { setErr(formatApiError(er)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/50 flex items-end sm:items-center justify-center">
      <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-white w-full max-w-md rounded-t-2xl sm:rounded-2xl p-5 space-y-3" data-testid="key-loan-dialog">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-lg font-extrabold">{back ? "Restitution" : "Prêt"} — {k.label}</h3>
          <button type="button" onClick={onClose} className="p-1"><X className="h-5 w-5" /></button>
        </div>
        {back ? <p className="text-sm text-slate-600">Prêté à <b>{k.loan.borrower_name}</b>{k.loan.borrower_company && ` (${k.loan.borrower_company})`} le {new Date(k.loan.lent_at).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}</p> : <>
          <input data-testid="loan-borrower-name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Nom de l'emprunteur *" className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm" />
          <input data-testid="loan-borrower-company" value={f.company} onChange={(e) => setF({ ...f, company: e.target.value })} placeholder="Société" className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm" />
        </>}
        <div className="text-xs font-semibold text-slate-600">Signature de l&apos;emprunteur (facultative)</div>
        <SignaturePad testid="loan-signature" onChange={setSig} />
        {err && <div data-testid="loan-error" className="text-sm text-rose-700">{err}</div>}
        <button data-testid="loan-submit" disabled={busy} className={`w-full text-white font-bold rounded-lg py-3 disabled:opacity-60 ${back ? "bg-emerald-600" : "bg-[#0B2A7A]"}`}>{busy ? "Enregistrement…" : back ? "Confirmer la restitution" : "Confirmer le prêt"}</button>
      </form>
    </div>
  );
}

export function AgentKeys() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => http.get("/agent-app/keys").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <section className="space-y-2" data-testid="agent-keys">
      <h2 className="font-display text-lg font-extrabold">Badges et clés</h2>
      {items.length === 0 && <div className="bg-white border border-slate-200 rounded-xl p-5 text-center text-sm text-slate-500">Aucun badge ni clé enregistré sur vos sites.</div>}
      {items.map((k) => {
        const Icon = k.kind === "badge" ? IdCard : KeyRound;
        return (
          <div key={k.id} className="bg-white border border-slate-200 rounded-xl p-3 flex items-center gap-3" data-testid={`agent-key-${k.id}`}>
            <Icon className={`h-5 w-5 ${k.loan ? "text-amber-600" : "text-emerald-600"}`} />
            <div className="flex-1 min-w-0">
              <div className="font-bold text-sm truncate">{k.label}</div>
              <div className="text-xs text-slate-500 truncate">{k.site_name} · {k.loan ? `prêté à ${k.loan.borrower_name}${k.loan.borrower_company ? ` (${k.loan.borrower_company})` : ""}` : "disponible"}</div>
            </div>
            <button data-testid={`agent-key-action-${k.id}`} onClick={() => setSel(k)} className={`text-sm font-bold rounded-lg px-3 py-2 text-white ${k.loan ? "bg-emerald-600" : "bg-[#0B2A7A]"}`}>{k.loan ? "Restituer" : "Prêter"}</button>
          </div>
        );
      })}
      {sel && <LoanDialog k={sel} onClose={() => setSel(null)} onDone={() => { setSel(null); load(); }} />}
    </section>
  );
}
